// src/Components/moderation/ModerationHub.jsx
import React, { useState } from 'react';
import { ShieldAlert, ShieldOff, Users, FileText } from 'lucide-react';
import ReportedContentQueue from './ReportedContentQueue';
import BlockedUsersPage from './BlockedUsersPage';
import UserManagementPage from './UserManagementPage';
import ContentManagementPage from './ContentManagementPage';

const TABS = [
  { id: 'reports',  label: 'Reported Content',  icon: ShieldAlert, Component: ReportedContentQueue  },
  { id: 'blocked',  label: 'Blocked Users',      icon: ShieldOff,   Component: BlockedUsersPage      },
  { id: 'users',    label: 'User Management',    icon: Users,       Component: UserManagementPage    },
  { id: 'content',  label: 'All Content',        icon: FileText,    Component: ContentManagementPage },
];

export default function ModerationHub() {
  const [activeTab, setActiveTab] = useState('reports');
  const ActiveComponent = TABS.find(t => t.id === activeTab)?.Component || ReportedContentQueue;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-2">
          <ShieldAlert className="text-red-600" size={24} />
          Moderation
        </h1>
        <p className="text-sm text-gray-500">Reports, users, and content enforcement</p>
      </div>

      {/* Tab bar */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow">
        <div className="border-b border-gray-100 dark:border-gray-700 overflow-x-auto">
          <div className="flex min-w-max px-2">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveTab(id)}
                className={`flex items-center gap-2 px-4 py-3.5 text-sm font-medium transition border-b-2 whitespace-nowrap ${
                  activeTab === id
                    ? 'text-red-600 border-red-600'
                    : 'text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200'
                }`}
              >
                <Icon size={15} /> {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Active tab content — existing page components, untouched */}
      <ActiveComponent />
    </div>
  );
}